import { createAction } from '@reduxjs/toolkit'
import type { ParsedError, Service } from '@shared-core/features/notifications/models'
import { API_KNOWN_ERRORS, API_STATUS_INVALID_TOKEN } from '@shared-core/services/api'
import { parseErrors } from '@shared-core/store/utils'

type Config = {
  defaultError?: ParsedError
  service?: Service
  silent?: boolean
  modifyError?: (error: ParsedError) => ParsedError
}

const allowedErrors = [
  API_KNOWN_ERRORS.KYC_2_LEVEL_REQUIRED,
  API_KNOWN_ERRORS.KYC_LEVEL_REQUIRED,
  API_KNOWN_ERRORS.SERVICE_TEMPORARILY_UNAVAILABLE,
  API_KNOWN_ERRORS.TG_ALREADY_LINKED_TO_ANOTHER_ACCOUNT,
  API_KNOWN_ERRORS.PAYMENT_AMOUNT_EXCEEDS_LIMIT_ERROR,
  API_KNOWN_ERRORS.REQUEST_ERROR,
  API_KNOWN_ERRORS.RATE_LIMIT_EXCEEDED,
]

type Response = {
  errors?: Record<string, unknown>
  status?: string | null
  meta?: Record<string, unknown> | undefined | null
} | null

export const handleErrors = createAction(
  'notifications/handleErrors',
  (response: Response, { defaultError, service, silent, modifyError }: Config = {}) => {
    if (response?.status === API_STATUS_INVALID_TOKEN) {
      return { payload: { errors: [{ error: API_KNOWN_ERRORS.INVALID_TOKEN }] } }
    }

    const parsed = parseErrors(response?.errors, response?.meta, defaultError)
    const prepared = silent ? parsed.filter((err) => allowedErrors.includes(err.error)) : parsed
    const errors = modifyError ? prepared.map(modifyError) : prepared
    return { payload: { errors, service } }
  },
)
